export enum InputTheme {
  default = "default",
  text = "text",
}
